module.exports = __webpack_public_path__ + "img/action-btn-2.e60a8a96.png";